module.exports = __webpack_public_path__ + "img/scan.5ac35e8.svg";